/**
 * The formatters-custom file is a place to define custom formatters or to
 * override any of the baked-in formatters like phone number formatting.
 *
 * e.g. You may write something like below
 * export function address(profile) {
 *   return `111 Yext Street`;
 * }
 */

export function stripHTMLV2(content) {
  let value = !content ? "" :
    content['html'] ? content['html'] :
    content['markdown'] ? content['markdown'] : "";
  
  return stripHTML(value);
}

export function stripHTML(content) {
  if (!content) {
    return ""
  }
  // Replace <mark> tags so they are not removed
  content = content.replaceAll("<mark>","||mark||");  
  content = content.replaceAll("</mark>","||/mark||"); 
  // Remove HTML
  let newDiv = document.createElement("div");
  newDiv.innerHTML = content;
  let detailsAsText = newDiv.innerText;

  // Add <mark tags back>
  detailsAsText = detailsAsText.replaceAll("||mark||","<mark>");  
  detailsAsText = detailsAsText.replaceAll("||/mark||","</mark>"); 
  // Add spaces at the begining of sentences. 
  const addSpaceRegex = /[\.]([a-z,A-Z])/i;
  return detailsAsText.replace(addSpaceRegex, (m, ...a) => {return a ? `. ${a[0]}` : ""});
}

function escapeHtml(unsafe) {
    // Failsafe incase there is still html in the render. 
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
 }